<template>
  <v-app>
    <v-app-bar
      color="primary"
      dense
      short
      app
      absolute
      class="mb-2 pb-2"
    >
      <v-tabs align-with-title>
        <v-tab to="/">{{text.appBarText}}</v-tab>
        <v-tab to="/cities">Cities</v-tab>
        <v-tab to="/others">Others</v-tab>
        <v-tab to="/automation">Automation</v-tab>
      </v-tabs>
    </v-app-bar>
    
    
    <v-main>  
      <router-view v-bind:text="text" />
    </v-main>

    <Footer
    v-bind:copyRigth="text.copyRigth"
    v-bind:bottomNote="text.bottomNote"
    v-bind:contactEmail="text.contactEmail"
    />

  </v-app>
</template>

<script>
import Footer from "./components/footer.vue";
export default {
    name: 'App',
    components: { Footer },
    data() {
        return {
            text: '',
        }
    },
    methods: {
        getData() {
            let path = "/text.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.text = out;
            })
            .catch(err => { throw err });
        }
    },
    mounted() {
        this.getData();
    }
    
}
</script>



<style scoped>
.v-application a {
  color: white;
  text-decoration: none;
}

</style>>